// measurement-parent.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as Cesium from 'cesium';
import { ReportMapEntity } from '../../models/report-map-entity.model';

@Injectable({
    providedIn: 'root'
})
export class MeasurementParentService {
    private measurements = new BehaviorSubject<any[]>([]);
    private selectedMeasurement = new BehaviorSubject<any>(null);
    private addedPins: [number, number][] = [];
    private color = new Cesium.Color(0, 1, 1, 1);
    private polyline: any;
    private lastPinCoord: [number, number] | null = null;
    private distance = 0;
    private calculatedDistance = 0;
    private unit = 'm';
    private myPins: any[] = [];
    private pins: ReportMapEntity[] = [];
    private globeClickHandler?: (lat: number, lon: number) => void;

    constructor() {
        this.initializePolyline();
    }

    private initializePolyline(): void {
        this.polyline = {
            name: '',
            type: 'Distance',
            coordinates: [],
            color: this.color,
            width: 3.0,
            opacity: 0
        };
    }

    // registerGlobeClick(handler: (lat: number, lon: number) => void): void {
    //     this.globeClickHandler = handler;
    // }

    // unregisterListeners(): void {
    //     // Implementation will depend on your globe service
    //     // This should be handled by your globe component
    // }

    setUnitType(setUnit: string): void {
        this.unit = setUnit;
        this.updateDistance(this.unit);
    }

    private updateDistance(unit: string): void {
        switch(unit) {
            case 'm':
                this.calculatedDistance = Math.round(this.distance);
                break;
            case 'km':
                this.calculatedDistance = Math.round(1000 * this.distance / 1000) / 1000;
                break;
            case 'ft':
                this.calculatedDistance = Math.round(this.distance * 3.280839895);
                break;
            case 'mi':
                this.calculatedDistance = Math.round(1000 * (this.distance * 0.00062137)) / 1000;
                break;
        }
    }

    addMeasurementPinToMap(pin: ReportMapEntity): void {
        this.pins.push(pin);
        // Additional logic for adding pin to map
    }

    // private distanceBetweenTwoCoordinates(lat1: number, lon1: number, lat2: number, lon2: number): number {
    //     const R = 6371e3; // Earth's radius in meters
    //     const φ1 = lat1 * Math.PI/180;
    //     const φ2 = lat2 * Math.PI/180;
    //     const Δφ = (lat2-lat1) * Math.PI/180;
    //     const Δλ = (lon2-lon1) * Math.PI/180;

    //     const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
    //             Math.cos(φ1) * Math.cos(φ2) *
    //             Math.sin(Δλ/2) * Math.sin(Δλ/2);
    //     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    //     return R * c;
    // }

    // getDistance(): number {
    //     return this.calculatedDistance;
    // }

    // private drawPolyline(pins: [number, number][]): void {
    //     this.polyline.name = `${this.calculatedDistance} ${this.unit}`;
    //     this.polyline.coordinates = pins;
    //     this.polyline.showInOverlappingEntitiesUI = false;
    //     this.polyline.showInLayersUI = false;
    //     // Add polyline to map using your map service
    // }

    cleanUp(): void {
        // Remove polyline and pins from map using your map service
        this.addedPins = [];
        this.initializePolyline();
        this.lastPinCoord = null;
        this.distance = 0;
        this.calculatedDistance = 0;
        this.myPins = [];
        this.pins = [];
    }

    getNumberOfPins(): number {
        return this.pins.length;
    }

    getSegmentInfo(): any[] {
        const segments: any[] = [];
        let totalDistance = 0;

        for (let i = 0; i < this.pins.length - 1; i++) {
            const pin1 = this.pins[i];
            const pin2 = this.pins[i + 1];
            const distance = this.calculateDistance(
                pin1.getCenterpoint().latitude,
                pin1.getCenterpoint().longitude,
                pin2.getCenterpoint().latitude,
                pin2.getCenterpoint().longitude
            );
            totalDistance += distance;
            segments.push({
                from: pin1.getName(),
                to: pin2.getName(),
                dist: distance,
                totalDist: totalDistance
            });
        }

        return segments;
    }

    private calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
        const R = 6371e3; // Earth's radius in meters
        const φ1 = lat1 * Math.PI/180;
        const φ2 = lat2 * Math.PI/180;
        const Δφ = (lat2-lat1) * Math.PI/180;
        const Δλ = (lon2-lon1) * Math.PI/180;

        const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ/2) * Math.sin(Δλ/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

        return R * c; // Distance in meters
    }

    // addMeasurement(measurement: any): void {
    //     const current = this.measurements.getValue();
    //     this.measurements.next([...current, measurement]);
    // }

    // removeMeasurement(measurementId: string): void {
    //     const current = this.measurements.getValue();
    //     this.measurements.next(current.filter(m => m.id !== measurementId));
    // }

    // selectMeasurement(measurement: any): void {
    //     this.selectedMeasurement.next(measurement);
    // }

    // getMeasurements(): Observable<any[]> {
    //     return this.measurements.asObservable();
    // }

    // getSelectedMeasurement(): Observable<any> {
    //     return this.selectedMeasurement.asObservable();
    // }
}